/**
 * Pendo tracking mechanism only. Ids are business vocabulary, so each feature
 * declares its own with `definePendoIds` next to the code it tags.
 */

declare const pendoBrand: unique symbol;

/** A declared Pendo id. Branded so raw strings can't be passed by mistake. */
export type PendoId = string & { readonly [pendoBrand]: true };

/** Mix into any component that forwards a Pendo selector to its root element. */
export interface PendoProps {
    "data-pendo"?: PendoId;
}

/** Declares a feature's Pendo ids. Keep the values unique across features. */
export function definePendoIds<const T extends Record<string, string>>(ids: T) {
    return ids as { [K in keyof T]: T[K] & PendoId };
}

/** Spread onto any element: `<div {...pendo(FEATURE_PENDO.thing)} />`. */
export function pendo(id: PendoId) {
    return { "data-pendo": id };
}

/**
 * Id for a column's show/hide row in the Adjust view dropdown. Structural, so
 * the shared table can build it from the caller's column id.
 */
export function adjustViewToggleId(columnId: string) {
    return `adjust-view-${columnId}-toggle` as PendoId;
}
